<template>
  <header @click="$emit('click')">
    <h1 v-if="title" :class="{ small }" class="secondary-font">
      {{ title }}
    </h1>

    <div v-if="$slots['title']" class="title">
      <slot name="title" />
    </div>

    <div class="actions">
      <slot name="actions" />
    </div>
  </header>
</template>

<script>
export default {
  props: {
    title: String,
    small: Boolean,
  },
};
</script>

<style lang="scss" scoped>
header {
  display: flex;
  align-items: center;
  margin-bottom: $gp;
  justify-content: space-between;
  min-width: 0;
}

h1 {
  flex: 1;
  margin-bottom: 0;
  @include ellipsis;

  &:not(.small) {
    text-transform: uppercase;
  }
}

.small {
  font-size: 24px;
  font-family: $font-family;

  @media($medium-down) {
    font-size: 18px;
  }
}

.actions {
  margin-left: $gp;
}
</style>
